// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function FileListBulleted(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "FileListBulleted" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 21V3H14L19 7V21H5ZM11 9.5H16V11H11V9.5ZM11 12.5H16V14H11V12.5ZM16 15.5H11V17H16V15.5ZM9.5 9.5H8V11H9.5V9.5ZM8 12.4831H9.5V13.9831H8V12.4831ZM9.5 15.5H8V17H9.5V15.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=FileListBulleted.js.map